// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_9f9658', '__Inter_Fallback_9f9658'","fontStyle":"normal"},"className":"__className_9f9658","variable":"__variable_9f9658"};